import { FieldOptionBase } from 'module/api/field/types';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { InputStyle } from 'module/ui/components/atoms/input/input';
import { Select as SelectAtom } from 'module/ui/components/atoms/select';
import { ActionPanel } from 'module/ui/components/molecules/action-panel';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import {
  components as ReactSelectComponents,
  DropdownIndicatorProps,
} from 'react-select';
import styled from 'styled-components';

const { Popover: CommonPopover } = ActionPanel;

const PopoverComponent = styled(CommonPopover)`
  font-family: var(--ozn-font-sans);
  width: 296px;
  height: min-content;
  overflow: hidden;
`;

const Popover: typeof CommonPopover = PopoverComponent as any;

Popover.Title = CommonPopover.Title;

const DropdownIndicator = (
  props: DropdownIndicatorProps<FieldOptionBase, true>,
) => (
  <ReactSelectComponents.DropdownIndicator {...props}>
    <FontAwesomeIcon icon={faSearch} style={{ marginRight: 8 }} />
  </ReactSelectComponents.DropdownIndicator>
);

export const StyledSelect = styled(SelectAtom)`
  .ozone-select__control {
    display: flex;
    flex: 1;
  }
`;

const Select = styled(StyledSelect).attrs(({ components = {} }) => ({
  menuIsOpen: true,
  hideSelectedOptions: false,
  components: {
    DropdownIndicator,
    ...components,
  },
}))`
  font-family: var(--ozn-font-sans);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .ozone-select__control {
    margin: 0 var(--popover-spacing) var(--popover-spacing);
    flex: 1 0 auto;
  }

  .ozone-select__menu {
    border: none;
    box-shadow: none;
    position: initial;
    margin: 0;
    flex: 1 1 100%;
    overflow-y: auto;
  }

  .ozone-select__menu-list {
    max-height: 100%;
  }

  .ozone-select__value-container {
    min-height: 40px;
    max-height: 76px;
    overflow: hidden;
    overflow-y: auto;
  }

  .ozone-select__indicators {
    .ozone-select__indicator-separator {
      display: none;
    }

    .ozone-select__dropdown-indicator {
      display: initial;
    }
  }

  .ozone-select__option {
    cursor: pointer;
  }
`;

export const Trigger = styled.div`
  min-width: 240px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${InputStyle};
  gap: var(--spacing-03);
  ${FontAwesomeIcon} {
    color: var(--icon-secondary);
  }
`;

export { Popover, Select };
